import React, { useState, useEffect } from "react";
import { userDetails } from "../../../../../../../helper";
import {
  getAssiginAuditorListingServices,
  saveAcceptRejectLevelApprover,
} from "../../../../../AssesmentForm/TabsComponents/Action";
import { useDispatch, useSelector } from "react-redux";
import Toaster from "../../../../../../common/Toaster";
import { useHistory } from "react-router-dom";
import { fetchSupplierNeedApprovalList } from "../Action";
import HeaderTitle from "../../../../../../common/HeaderTitle";
import { SearchableSelectHookForm } from "../../../../../../layout/HookFormInputs";
import { Col, Container, Label, Row } from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import LoaderCustom from "../../../../../../common/LoaderCustom";
import { Drawer } from "@material-ui/core";
import { reactLocalStorage } from "reactjs-localstorage";

const ViewApprovalSummarySnf = ({ selfAssesmentId, WorkFlowProcess, viewDataFromSupplier, employeeCode }) => {
  const formController = useForm({
    defaultValues: {
      // Commercial: "true",
    },
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const {
    register,
    setValue,
    reset,
    handleSubmit,
    formState: { errors },
    control,
    getValues
  } = formController;
  const { supplierNeedApprovalList } = useSelector(
    (state) => state?.getAllSupplierNeedApproval
  );
  const EmpId = userDetails();
  const [selectedAuditor, setSelectedAuditor] = useState(null); // State to store the selected auditor
  const dispatch = useDispatch();
  const [submitLoading, setSubmitLoading] = useState(false); // State to manage loading status
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState(""); // State to keep track of the action
  const history = useHistory();

  const [assignAuditorListing, setAssignAuditorListing] = useState([]);
  const NSAAuditorName = supplierNeedApprovalList?.Data?.NSAAuditorName;
  const NSAAuditorId = supplierNeedApprovalList?.Data?.NSAAuditorId;
  const IsNSARequiredVisible = supplierNeedApprovalList?.Data?.IsNSARequired;
  const [commercialRadio, setCommercialRadio] = useState("");
  const [formError, setFormError] = useState('');
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const onSubmit = async (data, action) => {
    if (!data?.remark) {
      // setFormErrorForCorrection("Please enter a remark");
      return;
    }
    const isNsaRequired = getValues("Commercial") === "true";
    const userDetail = userDetails();
    const reviewRequesterData = {
      Action: action,
      remark: data?.remark,
      WorkflowLevel: parseInt(WorkFlowProcess),
      EmployeeId: parseInt(userDetail?.EmployeeId),
      vendorRequirementRegistrationId: parseInt(selfAssesmentId, 10),
      IsFinalLevelApprover: supplierNeedApprovalList?.Data?.IsFinalLevelApprover,
      IsNSARequired: !supplierNeedApprovalList?.Data?.IsNSASectionVisible ? false : isNsaRequired,
      NSAAuditorId: selectedAuditor?.value,
    };
    // Check if NSA section is visible and validations


    try {
      setSubmitLoading(true);
      const res = await new Promise((resolve) => {
        dispatch(saveAcceptRejectLevelApprover(reviewRequesterData, resolve));
      });

      if (res && res?.IsSuccessful) {
        const receiverId = reactLocalStorage.getObject('receiverId');
        const hasValidReceiverId = receiverId !== null && receiverId !== undefined;
        reactLocalStorage.setObject('receiverId', null);
        Toaster.success(res?.Data?.Message);
        if (viewDataFromSupplier?.IsBlockedVendor) {
          history.push(hasValidReceiverId ? "/" : "/supplier-unblocking-request");
        } else {
          history.push(hasValidReceiverId ? "/" : "/vendor-need-list");
        }
      }
    } catch (error) {
      setSubmitLoading(false);
      // Handle error appropriately, such as displaying an error message
      // Toaster.error("An error occurred during submission.");
    } finally {
      setSubmitLoading(false);
    }
  };

  const changeHandler = (e, field) => {
    const value = e.target.value;
    if (value.length <= 500) {
      field.onChange(value);
      setFormError('');
    } else {
      setFormError('Remark cannot exceed 500 characters.');
    }
  };
  const getAssignAuditorListing = () => {
    getAssiginAuditorListingServices()
      .then((res) => {
        setAssignAuditorListing(res?.Data);
      })
      .catch(() => { });
  };
  const disabledFunctionality =
    supplierNeedApprovalList?.Data?.IsNSASectionDisable;

  const getVendorNeedApprovalList = (id) => {
    dispatch(fetchSupplierNeedApprovalList(id));
  };
  useEffect(() => {
    let IsNSARequiredVisibleValue = IsNSARequiredVisible?.toString();
    let formValues = getValues();

    reset({
      ...formValues,
      Commercial: IsNSARequiredVisibleValue
    });

    setValue("AssignAuditor", {
      value: NSAAuditorId || "",
      label: NSAAuditorName,
    });

    setCommercialRadio(IsNSARequiredVisibleValue === "true" ? "true" : "false");

  }, [NSAAuditorId, NSAAuditorName, IsNSARequiredVisible]);

  useEffect(() => {
    getVendorNeedApprovalList({
      vendorRequirementRegistrationId: selfAssesmentId,
      employeeId: EmpId?.EmployeeId,
      workflowlevel: WorkFlowProcess,
      EmployeeCode:employeeCode
    });
    getAssignAuditorListing();
  }, []);
  const renderListing = (label) => {
    if (label === "assignAuditor") {
      return assignAuditorListing.map((typeofEstablishment) => ({
        value: typeofEstablishment.Id,
        label: typeofEstablishment.Name,
      }));
    }
  };
  const handleAuditorChange = (selectedValue) => {
    setSelectedAuditor(selectedValue);
    // You can perform any additional actions with the selected value here
  };
  const convertISOToUtcDate1 = (isoDate) => {
    const date = new Date(isoDate);
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure month is two digits
    const day = String(date.getDate()).padStart(2, "0"); // Ensure day is two digits
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0"); // Ensure hours is two digits
    const minutes = String(date.getMinutes()).padStart(2, "0"); // Ensure minutes is two digits
    const seconds = String(date.getSeconds()).padStart(2, "0"); // Ensure seconds is two digits
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <>
    
    <div className="container-fluid approval-summary-drawer d-flex flex-column pb-5">
      <div className="h-100">
        <Row className="process workflow-row">
          {supplierNeedApprovalList?.Data?.VNFApprovalDetail?.map(
            (item, index) => (
              <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-4">
                <div
                  className={`card-border ${item.Status === 1
                    ? "card-green"
                    : item.Status === 0
                      ? "card-yellow"
                      : item.Status === 2
                        ? "card-red"
                        : ""}`}
                >
                  <div className="top d-flex">
                    <div className="left text-center">
                      <b>{item.WorkFlowLevel}</b>
                      <span className="d-block">Level</span>
                    </div>
                    <div className="right">
                      <span title={item.EmployeeName}>{item.EmployeeName}</span>
                      <p>{item.ApprovedBy ? item.ApprovedBy : "-"}</p>
                    </div>
                  </div>
                  {/* top */}
                  <div className="bottom">
                    <div className="d-flex mb-1">
                      <span className="small-grey-text left">Date:</span>
                      <span className="right">
                        {new Date(item.ActionTakenDate).toLocaleDateString()}
                      </span>
                    </div>
                    <div className="d-flex">
                      <span className="small-grey-text left">Remark:</span>
                      <span className="right remark-wrapper" title={item.Remark}>
                        {item.Remark ? item.Remark : "-"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )
          )}
        </Row>
        {supplierNeedApprovalList?.Data?.VNFApprovalReviewRequestModel?.map(
          (item, index) => (
            <div key={index}>
              <hr className="hr-seprator mb-4" />
              <div
                accordionId={index.toString()}
                className="hl-need-form ps-3 hl-request-scroll"
              >
                <div className="review-request pl-0 pt-3">
                  <div className="remarks-wrap">
                    <HeaderTitle title={"Requested By : " + item?.RequestedByName} customHeaderClass="fs-6" />
                    <p className="para-color">{item.ReviewRequestRemark}
                      <strong className="d-block hl-date-remark">
                        {convertISOToUtcDate1(item.ReviewRequestDate)}
                      </strong>
                    </p>
                    <hr className="hr-seprator" />
                  </div>
                  {item.ResponseRemark && (
                    <div className="remarks-wrap ml-4">
                      <HeaderTitle title={"Response By : " + item?.ResponseGivenByName} customHeaderClass="fs-6" />
                      <p className="para-color">{item.ResponseRemark}
                        <strong className="d-block hl-date-remark">
                          {convertISOToUtcDate1(item.ResponseDate)}
                        </strong>
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
        )}
      
        {supplierNeedApprovalList?.Data?.IsNSASectionVisible && (
          <>
            <hr className="hr-seprator mb-4" />
            <Row className="part-detail-wrapper d-flex">
              <Col md="12">
                <div className="hl-title-tooltip">
                  <Label className="d-inline-block align-middle w-auto pl-1 pr-5 mr-5 pr-4 pt-0">
                    NSA Required?
                    <span className="asterisk-required"></span>
                  </Label>
                </div>
              </Col>
              <Col md="12" className="d-flex">
                <Label
                  className={"d-inline-block align-middle w-auto pl0 pr-5 mr-5 mb-3 pl-2 pt-2 radio-box"}
                  check
                >
                  <input
                    type="radio"
                    name="Commercial"
                    className="zero-based"
                    id="IsExistingSupplierTrue"
                    {...register("Commercial", {
                      required: action !== "ReviewRequested" ? "This field is required." : false,
                     
                    })}
                    onChange={(e) => {
                      setCommercialRadio(e.target.value);
                      if (e.target.value == "true") {
                        setSelectedAuditor(null); // Reset dropdown when "No" is selected
                      }
                    }}
                    value="true"
                    disabled={disabledFunctionality}
                  />
                  <span>Yes</span>
                </Label>
                <Label
                  className={"d-inline-block align-middle w-auto pl0 mb-3 pt-0 radio-box pt-2"}
                  check
                >
                  <input
                    type="radio"
                    name="Commercial"
                    className="vendor-based"
                    id="IsExistingSupplierFalse"
                    {...register("Commercial", {
                      required: action !== "ReviewRequested" ? "This field is required." : false,
                    })}
                    onChange={(e) => {
                      setCommercialRadio(e.target.value);
                      if (e.target.value == "false") {
                        setSelectedAuditor(null); // Reset dropdown when "No" is selected
                      }
                    }}
                   
                    value="false"
                    disabled={disabledFunctionality}
                  />
                  <span>No</span>
                </Label>
              </Col>
              {errors.Commercial && (
                <Col md="12">
                  <span className="text-danger">{errors.Commercial.message}</span>
                </Col>
              )}
            </Row>
            <Row className="part-detail-wrapper hl-assign-auditor-wrap d-flex">
              <Col md="4">
                {commercialRadio == "true" && (
                  <SearchableSelectHookForm
                    className="testcls5"
                    // {...register("AssignAuditor")}
                    label={"Assign Auditor"}
                    name={"AssignAuditor"}
                    placeholder={"Select"}
                    Controller={Controller}
                    control={control}
                    rules={{ required: true }}
                    register={register}
                    options={renderListing("assignAuditor")}
                    disabled={disabledFunctionality}
                    mandatory={true}
                    handleChange={handleAuditorChange} // Pass the handleChange function
                    errors={errors.AssignAuditor} />
                )}
              </Col>
            </Row>
          </>
        )}
      </div>
      {supplierNeedApprovalList?.Data?.IsButtonVisible && (
        <div className="sf-btn-footer">
          <div className="col-sm-12 bluefooter-butn d-flex align-items-center justify-content-end pb-0">
            <React.Fragment key={""}>
              <button
                type="button"
                className="submit-button save-btn mb-0 mr5"
                onClick={() => {
                  setOpen(true);
                  // setOpenPendingDrawer(false)
                  setAction("ReviewRequested")
                }}
              >
                <div className="send-for-approval mr-1"></div>
                {"Request Review"}
              </button>
              <button
                type="submit"
                className="approve-button mr5 approve-hover-btn mb-0"
                onClick={() => {
                  setOpen(true);
                  // setOpenPendingDrawer(false)
                  setAction("Approved");
                }}
              >
                <div className="save-icon mr-1"></div>
                {"Accept"}
              </button>
              <button
                type={"button"}
                className="approve-reject-btn mb-0"
                onClick={() => {
                  setOpen(true);
                  // setOpenPendingDrawer(false)
                  setAction("Rejected")
                }}
              >
                <div className={"cancel-icon-white mr5"}></div>
                {"Reject"}
              </button>
            </React.Fragment>
          </div>
        </div>
      )}
    </div>
      <Drawer open={open} anchor="right" onClose={toggleDrawer(false)} >
        <Container>
          {submitLoading && <LoaderCustom customClass="simulation-Loader" />}
          <div className={"drawer-wrapper w-100 master-summary-drawer"} sx={{ minWidth: "450px" }}>
            <Row className="drawer-heading sticky-top-0">
              <Col>
                <div className={"header-wrapper left"}>
                  <h3>{"Add Remark"}</h3>
                </div>
                <div
                  onClick={() => setOpen(false)}
                  className={"close-button right"}
                ></div>
              </Col>
            </Row>
            <Row className="part-detail-wrapper pl-3 pr-3 flex-column">
              <Col md="12">
                <form onSubmit={handleSubmit((data) => onSubmit(data, action))}>
                  <div className="mb-3">
                    <label className="asterisk-sign text-left">
                      Add Remark<span className="asterisk-required">*</span>
                    </label>
                    <Controller
                      control={control}
                      name="remark"
                      rules={{ required: 'Remark is required' }}
                      render={({ field }) => (
                        <textarea
                          rows={3}
                          placeholder="Enter"
                          value={field.value}
                          onChange={(e) => changeHandler(e, field)}
                          className="form-control hl-textarea-h"
                          style={{ minWidth: "400px" }}
                        />
                      )}
                    />
                    {errors.remark && <p className="text-help">{errors.remark.message}</p>}
                    {formError && <p className="text-help">{formError}</p>}
                  </div >
                  <button type="submit" className="btn btn-primary">Submit</button>
                </form >
              </Col >
            </Row>
          </div>
        </Container>
      </Drawer >
    </>


  );
};
export default ViewApprovalSummarySnf;
